import {
  OPEN_PURCHASE_ORDER_DIALOG,
  CLOSE_PURCHASE_ORDER_DIALOG,
  GET_PURCHASE_ORDER_DATA,
  GET_PURCHASE_ORDER_DATA_SUCCESS,
  GET_PURCHASE_ORDER_DATA_ERROR
} from './UniqueSellersSection.actions'

const uniqueSellerState = {
  error: undefined,
  loading: true,
  searching: true,
  open: false,
  orders: [],
  filter: []
}

/**
 * The Unique Seller reducer.
 */
const uniqueSellerReducer = (state = uniqueSellerState, { type, payload }) => {
  switch (type) {
    case OPEN_PURCHASE_ORDER_DIALOG: {
      return {
        ...state,
        error: undefined,
        searching: true,
        open: true
      }
    }
    case CLOSE_PURCHASE_ORDER_DIALOG: {
      return {
        ...state,
        error: undefined,
        searching: false,
        open: false
      }
    }
    case GET_PURCHASE_ORDER_DATA: {
      return {
        ...state,
        error: undefined,
        searching: true,
        loading: true
      }
    }
    case GET_PURCHASE_ORDER_DATA_SUCCESS: {
      return {
        ...state,
        error: undefined,
        loading: false,
        searching: false,
        orders: [...payload?.orders]
      }
    }
    case GET_PURCHASE_ORDER_DATA_ERROR: {
      return {
        ...state,
        error: payload?.error?.reason,
        loading: false,
        searching: false,
        open: false,
        orders: []
      }
    }
    default: {
      return state
    }
  }
}

export default uniqueSellerReducer
